<button class="container" [ngbTooltip]="user.founder || userService.isSubscriptionPaid(user) ? tooltipSignatureCorporate : tooltipSignatureFree" container="body" (click)="goToPlanPage()">
  @if (!disableIcon) {
    <i class="fas fa-file-plus"></i>
  }
  @if (user) {
    <div class="documents">
      @if (user.founder || userService.isSubscriptionPaid(user) || user.subscription.documents > 999) {
        <div class="documents__monthly" [class.alwaysVisible]="user.subscription.bonus === 0 || user.founder || userService.isSubscriptionPaid(user)">
          <i class="far fa-infinity"></i>
        </div>
      } @else {
        <div class="documents__monthly" [class.alwaysVisible]="user.subscription.bonus === 0">
          {{ user.subscription.bonus > 0 ? user.subscription.bonus + user.subscription.documents : user.subscription.documents }}
        </div>
        @if (user.subscription.bonus > 0) {
          <div class="documents__bonus">{{ user.subscription.documents + ' + ' + user.subscription.bonus }}</div>
        }
      }
    </div>
  }

  <ng-template #tooltipSignatureFree>
    <div class="tooltip__descr">{{ 'shared.howManyDocumentsYouCanCreate' | translate }}</div>
  </ng-template>
  <ng-template #tooltipSignatureCorporate>
    <div class="tooltip__descr">{{ 'shared.youCanCreateUnlimitedDocuments' | translate }}</div>
  </ng-template>
</button>
